import { render, staticRenderFns } from "./IdeasPage.vue?vue&type=template&id=1e67228c&scoped=true&"
import script from "./IdeasPage.vue?vue&type=script&lang=js&"
export * from "./IdeasPage.vue?vue&type=script&lang=js&"
import style0 from "./IdeasPage.vue?vue&type=style&index=0&id=1e67228c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e67228c",
  null
  
)

export default component.exports